/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orderNumber: NonNullable<unknown> }} Orders_Estes_Rebook_Description_OneInputs */

const en_orders_estes_rebook_description_one = /** @type {(inputs: Orders_Estes_Rebook_Description_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Order ${i?.orderNumber} already has a tracking number. Do you want to rebook it?`)
};

const es_orders_estes_rebook_description_one = /** @type {(inputs: Orders_Estes_Rebook_Description_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El pedido ${i?.orderNumber} ya tiene numero de tracking. Quieres volver a reservarlo?`)
};

/**
* | output |
* | --- |
* | "Order {orderNumber} already has a tracking number. Do you want to rebook it?" |
*
* @param {Orders_Estes_Rebook_Description_OneInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_estes_rebook_description_one = /** @type {((inputs: Orders_Estes_Rebook_Description_OneInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Estes_Rebook_Description_OneInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_estes_rebook_description_one(inputs)
	return es_orders_estes_rebook_description_one(inputs)
});